import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
  return (
    <div className='footer'>
        <small>
          &copy; Copyright {new Date().getFullYear()}, Fashioniste. All Rights Reserved | 
          <Link to='/privacy-policy' style={{color: 'white', marginLeft: '10px', textDecoration: 'underline'}}>
            Privacy Policy
          </Link>
        </small>
    </div>
  )
}

export default Footer